import { render, staticRenderFns } from "./LifeInsuranceModal.vue?vue&type=template&id=62449032&"
import script from "./LifeInsuranceModal.vue?vue&type=script&lang=js&"
export * from "./LifeInsuranceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports